describe('Fakturacia', function() {
	var $rootScope, $scope, Profile, createController, controller, $httpBackend, Restangular;
  beforeEach(module('casist.core'));
	beforeEach(module('casist.sklad'));
  beforeEach(module('casist.ucto'));

  beforeEach(function(){
    this.addMatchers({
      toEqualData: function(expected) {
        return angular.equals(this.actual, expected);
      }
    });
  });

	beforeEach(inject(function(_$controller_, _$rootScope_, _Profile_, _$httpBackend_, _Faktura_) {
		$rootScope = _$rootScope_;
		Profile = _Profile_;
    Faktura = _Faktura_;
    $httpBackend = _$httpBackend_;
    $scope = $rootScope.$new();
    var $controller = _$controller_;
    createController = function() {
      return $controller('FakturaciaCtrl', {
        $scope: $scope
      });
    };
    
		Profile.set('agenda', {id: 1}, true);
		Profile.set('prevadzky', [{prevadzka: "Test", id: 1, agenda: 1}], true);
    Profile.set('perms', {faktura: {}});

    controller = createController();
	}));

  var fakturyData = [{"id":1,"iddokd":"VF150000001","uctovanie":{"suma5_md":null,"suma1_d":null,"d2_md":null,"d2_popis":"","zaklad_d0_md":null,"suma1_md":null,"suma3_md":null,"suma4_md":null,"suma2_popis":"","d1_popis":"","suma3_d":null,"spolu_popis":"","suma2_md":null,"d2_d":null,"d1_d":null,"spolu_md":null,"d1_md":null,"zaklad_d1_d":null,"zaklad_d2_popis":"","zaklad_d0_d":null,"spolu_d":null,"zaklad_d2_md":null,"suma1_popis":"","zaklad_d1_popis":"","zaklad_d2_d":null,"suma2_d":null,"suma5_popis":"","suma5_d":null,"suma4_d":null,"zaklad_d0_popis":"","zaklad_d1_md":null,"suma3_popis":"","suma4_popis":""},"rozuctovanie":[],"locked":null,"firma_data":{"id":1,"osoby":[],"prevadzky":[],"predkontacia_df_data":null,"predkontacia_pd_data":null,"adresa":" ","record_created":"2015-02-18T10:54:42Z","firma":"macav","ico":"","dic":"","icdph":"","ulica":"","cislo":"","mesto":"","psc":"","ucet":"","splatnost":0,"zlava":"0.00","tel":"","fax":"","mobil":"","email":"","web":"","adresat":"","poznamka":"","urok_fa":"0.00","predkontacia_df":null,"predkontacia_pd":null},"typdph_data":{"id":1,"typ":"R03","platne_od":"2014-01-01","platne_do":"2099-01-01","popis":"Zdaniteľné obchody v tuzemsku","modul":1,"nulldph":false,"default":true},"mena_data":null,"predkontacia_data":null,"record_created":"2015-02-18T10:54:47Z","uctovane":false,"rozuctovane":false,"popis":"","vs":150000001,"dd":1,"d_vyst":"2015-02-18","d_zdp":"2015-02-18","d_splat":"2015-02-28","d_uctn":"2015-02-18","uplat_dph":"2015-02-18","m_uct":null,"m_dph":null,"poznamka":"","sd1":20,"sd2":10,"zaklad_d1":"100.0000","d1":"20.0000","zaklad_d2":"0.0000","d2":"0.0000","zaklad_d0":"0.0000","spolu":"120.000000","suma1":"0.0000","suma2":"0.0000","suma3":"0.0000","suma4":"0.0000","suma5":"0.0000","uhradene":"0.0000","kurz":"0.0000","spolu_zm":"0.0000","primarna_zm":false,"hlavicka":null,"pata":null,"objednavka":"","doprava":"","zlava":"0.00","predajca":"","povodna_faktura_cislo":null,"predkontacia":null,"prevadzka":1,"obdobie":null,"typ_dph":1,"firma":1,"mena":null,"konecny_prijemca":null}];

	it('should have controller defined', function() {
		expect(controller).toBeDefined();
		expect($scope.prevadzky).toBeDefined();
		expect($scope.prevadzky.length).toBeGreaterThan(0);
	});

  it('should load backend data', function() {
    $httpBackend.expectGET('/faktury?d_zdp__gte=2015-01-01&d_zdp__lte=2015-12-31&dd=1&ordering=iddokd&page=last').respond(fakturyData);
    $httpBackend.flush();

    expect(Faktura.stripRestangular($scope.faktury)).toEqualData(fakturyData);
  });
});